export default __webpack_public_path__ + "static/media/surgical.dcb34dbc.svg";